
define('text!templates/appMain/privilegedMain/composer/forms/embeddedQualityFormEditor.html',[],function () { return '<iframe class="qf-embedded" data-bind="attr: { src: formUrl }" title="Quality Forms">\n</iframe>\n';});

